export default __webpack_public_path__ + "static/media/sc.b5f71b2e.ico";